import { useEffect, useState } from 'react';

export function useIsMobileViewport(breakpoint: number): boolean {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === 'undefined') {
      return false;
    }
    return window.innerWidth < breakpoint;
  });

  useEffect(() => {
    if (typeof window === 'undefined') {
      return undefined;
    }

    const checkViewport = () => {
      setIsMobile(window.innerWidth < breakpoint);
    };

    checkViewport();
    window.addEventListener('resize', checkViewport);

    return () => {
      window.removeEventListener('resize', checkViewport);
    };
  }, [breakpoint]);

  return isMobile;
}
